import { render, staticRenderFns } from "./v-cancel.vue?vue&type=template&id=65b04b4e&"
import script from "./v-cancel.vue?vue&type=script&lang=js&"
export * from "./v-cancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports